<template>
  <footer>
    <cookie-law :button-text="$t('buttons.accept')" theme="base sma"  :class="[{'demo':componentStyle.mode=='demo'},{'reverseCookie':componentStyle.reverseFooter}]" >

      <div slot="message" v-if="componentStyle.mode=='default'">
        {{ $t('labels.footer') }}
        <!--<router-link to="legal-notes">En savoir plus</router-link>-->
      </div>

      <div slot="message" class="message" v-if="componentStyle.mode=='demo'">
        <i class="icon-demo-shield cookie-icon"></i>
        <div class="text-demo">
        Nous utilisons des cookies sur ce site pour améliorer votre expérience utilisateur.<br>
        Pour un aperçu complet de tous les cookies utilisés,          <router-link to="legal-notes"> veuillez consulter vos paramètres personnels. </router-link>

        </div>
      </div>



    </cookie-law>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import { mapGetters } from 'vuex';

export default {
  name: 'PageFooter',
  components: {
    CookieLaw,
  },
  computed: {
    ...mapGetters({
      componentStyle: 'layout/getComponentStyle',
    }),
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import '../assets/scss/_variables';
.reverseCookie {
  &.sma {
    background-color: $secondary-color !important;
    background-color: var(--secondary-color) !important;
    color: #ffffff;
    padding: 0.8em 1.25em;
    opacity: 0.9;
    a {
      color: #ffffff;
      font-weight: bold;
      text-decoration: underline;
      &:hover {
        color: #ffffff;
      }
    }
  }
  .Cookie__button {
    background-color: $primary-color !important;
    background-color: var(--primary-color) !important;
    color: #6a7887!important;
    border-radius: 2px !important;
    &:hover {
      background-color: darken(#ffff, 10%) !important;
    }
  }
}

:not(.reverseCookie).Cookie  {
  &.sma {
    background-color: $primary-color !important;
    background-color: var(--primary-color) !important;
    color: #ffffff;
    padding: 0.8em 1.25em;
    opacity: 0.9;
    a {
      color: #ffffff;
      font-weight: bold;
      text-decoration: underline;
      &:hover {
        color: #ffffff;
      }
    }
  }
  .Cookie__button {
    background-color: $secondary-color !important;
    background-color: var(--secondary-color) !important;
    border-radius: 2px !important;
    &:hover {
      background-color: darken(#ffff, 10%) !important;
    }
  }
}

  /* theme demo  */

@media screen and(max-width: 467px) {
  .Cookie.demo.sma{
    height: 225px;
  }
  .text-demo{
    font-size: 12px!important;
  }
  .cookie-icon {
    font-size: 2em!important;
    padding-bottom: 0.2em!important;
  }
}


@media screen and(max-width: 992px) {
  .Cookie.demo.sma{
    height: 225px;

    display: flow-root;
    justify-content: center;
  }
  .cookie-icon{
    margin-top: 0.5em;
  }
  .Cookie.demo .message .text-demo{
    font-size: 16px!important;

  }
  .message{
    font-family: Roboto;
    font-size: 16px!important;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    margin-bottom: 0.5em;
  }
  .Cookie__buttons {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}





.Cookie.demo {
  padding: 0 10vw!important;
  height: 158px;
  &.sma {
    background-color: #313131!important;
    color: #ffffff;
    padding: 0.8em 1.25em;
    opacity: 0.9;
    a {
      color: #ffffff;
      font-weight: bold;
      text-decoration: underline;
      &:hover {
        color: #ffffff;
      }
    }
  }
  .message{
    display: flex;
    justify-content: space-around;
    align-items: center;
    .text-demo{

      font-family: Roboto;
      font-size: 18px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
    }
    a{
      font-weight: 300!important;
    }
  }

  @media screen and(max-width: 992px) {
    .message{
      display: flow-root;
      i{
        display: flex;
        justify-content: center;
      }
      .cookie-icon{
        font-size: 3em;
        padding-bottom: 0.5em;
      }

      button{
        padding: 0.2em;
        margin: 0em!important;

      }

    }

  }


}
.demo .Cookie__button {
  text-transform: uppercase;
  background-color: #6e6e6e !important;
  border-radius: 2px !important;
  &:hover {
    background-color: darken(#ffff, 10%) !important;
    color: #6e6e6e!important;
  }
}

.cookie-icon{
  font-size: 5em;
  margin-right: 3vw;
  color: #a1a1a1;
}

/* darck mode*/
  #app.darkMode{
    .icon-demo-shield:before{
      color:#d2d2d2!important;
    }
    .Cookie.demo {
      &.sma {
        background-color: #a1a1a1!important;
        color: #131313;
        padding: 0.8em 1.25em;
        opacity: 0.9;
        a {
          color: #131313;
          font-weight: bold;
          text-decoration: underline;
          &:hover {
            color: #131313;
          }
        }
      }
      .message{
        display: flex;
        justify-content: space-around;
        align-items: center;

      }
    }
    .demo .Cookie__button {
      background-color: #d2d2d2 !important;
      color:#131313!important; ;
      border-radius: 2px !important;
      &:hover {
        background-color: darken(#ffff, 10%) !important;
        color: #6e6e6e!important;
      }
    }
    @media screen and(max-width: 992px) {
      .message{
        display: flow-root!important;
        i{
          display: flex!important;
          justify-content: center!important;
        }
        .cookie-icon{
          font-size: 3em;
          padding-bottom: 0.5em;
        }
        .text-demo{
          font-size: 12px;
        }
        button{
          padding: 0.2em;
          margin: 0em!important;

        }

      }

    }
  }



</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue